export default __webpack_public_path__ + "static/bg6-h-5dc649d6da990c94180ed6a761d0a356.jpg";